const BASE = process.env.REACT_APP_BACKEND_URL;

export const avatarSrc = (url) => (url ? (url.startsWith("/") ? `${BASE}${url}` : url) : "");

export function UserAvatar({ user, className = "avatar", testId }) {
  const initials = (user?.name || "?").split(" ").filter(Boolean).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  const src = avatarSrc(user?.avatarUrl);
  return (
    <div className={`${className}${src ? " has-photo" : ""}`} data-testid={testId}>
      {src ? <img src={src} alt={user?.name || "Profil"} referrerPolicy="no-referrer" /> : initials}
    </div>
  );
}
